import { useMemo } from 'react';
import { selectorClassGeneratorBasedOnComponent } from '../../../styling';
import { appendClassName } from '../../../utils';
export var useSwitchClassName = function useSwitchClassName(classPrefix, className, disabled, checked) {
  return useMemo(function () {
    return {
      Root: appendClassName(selectorClassGeneratorBasedOnComponent({
        component: 'Root',
        classPrefix: classPrefix,
        disabled: disabled,
        checked: checked
      }), className),
      Label: selectorClassGeneratorBasedOnComponent({
        component: 'Label',
        classPrefix: classPrefix,
        disabled: disabled,
        checked: checked
      }),
      CheckboxInput: selectorClassGeneratorBasedOnComponent({
        component: 'CheckboxInput',
        classPrefix: classPrefix,
        disabled: disabled,
        checked: checked
      }),
      Slider: selectorClassGeneratorBasedOnComponent({
        component: 'Slider',
        classPrefix: classPrefix,
        disabled: disabled,
        checked: checked
      })
    };
  }, [classPrefix, className, disabled, checked]);
};